import { AdminMessage } from "@components/admin/admin-helpers"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { defineBlock, EditableText } from "eddev/blocks"
import { Link } from "eddev/routing"

export const meta: BlockMeta = {
  title: "Sponsors",
  description: "Displays the tagged sponsors of this film",
  icon: "groups",
  tags: ["film-sidebar"],
}

export default defineBlock("film/film-sponsors", (props) => {
  const hasSponsors = !!props.film?.sponsors?.length

  if (!hasSponsors) {
    if (env.admin) {
      return <AdminMessage>No sponsors</AdminMessage>
    }
    return null
  }
  return (
    <div data-mixpanel-area="Film Sponsors" className="mb-4">
      <EditableText store="label" as="div" defaultValue="Presented By" className="type-label-caps mb-3" />
      <div className="flex flex-col gap-2">
        {props.film?.sponsors?.map((sponsor, i) => {
          let content = sponsor?.sponsorInfo?.image ? (
            <div className="max-w-full" style={{ width: 150 * (sponsor?.sponsorInfo?.scale ?? 1) }}>
              <ResponsiveImage {...sponsor?.sponsorInfo?.image} />
            </div>
          ) : (
            // TODO: External link icon?
            <span className="type-ui-m">{sponsor?.title}</span>
          )
          if (sponsor?.sponsorInfo?.link) {
            content = (
              <Link href={sponsor?.sponsorInfo?.link} target="_blank" className="flex">
                {content}
              </Link>
            )
          }
          return <div key={i}>{content}</div>
        })}
      </div>
    </div>
  )
})
